import React from "react";
import "./Footer.css";
import linkedin from "../../assets/linkedin.png";
import website from "../../assets/ux.png";
import youtube from "../../assets/youtube.png";
import email from "../../assets/gmail.png";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="zuppa_lms_foot_pg_footer">
        <div className="zuppa_lms_foot_pg_wrapper">
          <canvas className="zuppa_lms_foot_pg_canvas" id="test"></canvas>

          <div className="zuppa_lms_foot_pg_container">

            {/* Left - Brand */}
            <div className="zuppa_lms_foot_pg_brand">
              <Fade direction="left">
                <img
                  className="zuppa_lms_foot_pg_logo"
                  src="https://res.cloudinary.com/dwrwkl5b3/image/upload/v1772788453/ChatGPT_Image_Mar_6_2026_02_43_41_PM_ijoait.png"
                  alt="Zuppa Logo"
                />
              </Fade>
              <h4 className="zuppa_lms_foot_pg_brand_name">
                Zuppa Geo Navigation Technologies
              </h4>
              <p className="zuppa_lms_foot_pg_brand_sub">Private Limited</p>
            </div>

            {/* Center - Social Links */}
            <div className="zuppa_lms_foot_pg_social">
              <h3 className="zuppa_lms_foot_pg_social_title">Reach Out</h3>
              <div className="zuppa_lms_foot_pg_social_icons">
                <Link
                  to="https://www.linkedin.com/company/zuppa-drones/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="zuppa_lms_foot_pg_icon_link"
                >
                  <img src={linkedin} alt="LinkedIn" className="zuppa_lms_foot_pg_icon_img" />
                  <span className="zuppa_lms_foot_pg_icon_label">LinkedIn</span>
                </Link>

                <Link
                  to="https://shop.zuppa.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="zuppa_lms_foot_pg_icon_link"
                >
                  <img src={website} alt="Website" className="zuppa_lms_foot_pg_icon_img" />
                  <span className="zuppa_lms_foot_pg_icon_label">Website</span>
                </Link>

                <Link
                  to="https://www.youtube.com/@zuppageonavigationtechnologies"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="zuppa_lms_foot_pg_icon_link"
                >
                  <img src={youtube} alt="YouTube" className="zuppa_lms_foot_pg_icon_img" />
                  <span className="zuppa_lms_foot_pg_icon_label">YouTube</span>
                </Link>

                <a
                  href="mailto:askme@zuppa.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="zuppa_lms_foot_pg_icon_link"
                >
                  <img src={email} alt="Email" className="zuppa_lms_foot_pg_icon_img" />
                  <span className="zuppa_lms_foot_pg_icon_label">Email</span>
                </a>
              </div>
            </div>

            {/* Right - Address */}
            <div className="zuppa_lms_foot_pg_address">
              <h3 className="zuppa_lms_foot_pg_address_title">Find Us</h3>
              <address className="zuppa_lms_foot_pg_address_body">
                <p className="zuppa_lms_foot_pg_address_line">PolyHose Tower No: 86,</p>
                <p className="zuppa_lms_foot_pg_address_line">West Wing, 4th Floor,</p>
                <p className="zuppa_lms_foot_pg_address_line">AnnaSalai, Guindy</p>
                <p className="zuppa_lms_foot_pg_address_line">Chennai - 600032</p>
              </address>
            </div>

           
          </div>
        </div>

        {/* Copyright */}
        <div className="zuppa_lms_foot_pg_copyright">
          <p className="zuppa_lms_foot_pg_copyright_text">
            © 2024 Zuppa Drone LMS. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;